// extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__qEpq4","bodyContainer":"styles_bodyContainer__CKlqN"};